export interface EventWizardDescriptionMarkdownProps {
  description: string;
  onUpdate: (desc: string) => void;
  isErrorState?: boolean;
}

export const getPlainTextFromMarkdown = (text: string): string => {
  return text.replace(/<[^>]+>/g, '');
};

export const removeLineSpaces = (text: string): string => {
  return text.replace(/\s+/g, ' ');
};
